import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/serviceWorker.js');
      console.log('ServiceWorker registration successful:', registration.scope);

      // Check for updates on page load
      if (registration.waiting) {
        console.log('New service worker waiting');
      }

      // Periodically check for updates
      setInterval(() => {
        registration.update().catch(err => {
          console.error('Error updating service worker:', err);
        });
      }, 60 * 60 * 1000); // Check every hour

    } catch (error) {
      console.error('ServiceWorker registration failed:', error);
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
